import React, { cloneElement, useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import {
  List,
  downloadCSV,
  Pagination,
  Datagrid,
  DateField,
  ReferenceField,
  TextField,
  BooleanField,
  EditButton,
  ShowButton,
  Filter,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  SelectInput,
  TopToolbar,
  RefreshButton,
  ExportButton,
  usePermissions,
  useResourceContext,
  useRecordContext,
  useTranslate,
  DateTimeInput,
  SelectArrayInput,
  Button,
  useDataProvider,
  useNotify,
  useUnselectAll,
} from "react-admin";
import {
  ExpectedDateField,
  CamelCaseField,
  PaymentAmountField,
  OrderStatus,
} from "./common";
import {
  getDigitalOrderStatusChoices,
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import moment from "moment";
// import { DateTimeInput } from "react-admin-date-inputs";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const selectInputStyle = {
  width: 200,
};

const DigitalOrdersFilter = ({ permissions, location, ...props }) => {
  const translate = useTranslate();
  const localStorageLocale = getLocalStorageKey("locale");
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const isMdd = getLocalStorageKey("enable_mdd_mode");
  const isFca = getLocalStorageKey("enable_fca_mode");
  let modeOfDeliveryArray = [
    { id: "self_collect", name: "Collect" },
    { id: "delivered", name: "Delivered" },
  ];

  if (isMdd) {
    modeOfDeliveryArray.push({ id: "MDD", name: "MDD" });
  }

  if (isFca) {
    modeOfDeliveryArray.push({ id: "agency", name: "Agency" });
  }

  // const handleChange = (event) => {
  //     console.log('event selected=====>', event);
  //     let now = new Date();
  //     // let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0,0,0,0));
  //     event = (moment(event).subtract(2, 'days').format("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")); //((moment(event).format('MM/DD/YYYY')) - (moment(event).add(2, 'days').format('MM/DD/YYYY')));
  //     console.log('new modified event=====>', event);
  //     return event;
  // };
  // const dateFormatter = v => {
  //     // v is a `Date` object
  //     if (!(v instanceof Date) || isNaN(v)) return;
  //     console.log('v====>',v);
  //     const pad = '00';
  //     const yy = v.getFullYear().toString();
  //     const mm = (v.getMonth() + 1).toString();
  //     const dd = v.getDate().toString();
  //     console.log('return val====>',`${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`);
  //     return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
  //   };

  //   const dateParser = v => {
  //     // v is a string of "YYYY-MM-DD" format
  //     const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  //     if (match === null) return;
  //     const d = new Date(match[1], parseInt(match[2], 10) - 1, match[3]);
  //     if (isNaN(d)) return;
  //     console.log('d====>', d);
  //     return d;
  //   };
  //format={dateFormatter} parse={dateParser}

  return (
    <Filter {...props}>
      <ReferenceInput
        // label="Sold To Name"
        source="business_id"
        reference="businesses"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>

      {localStorageLocale == "en-GB" && (
        <TextInput
          label="Sent to E1 by"
          source="admin_user_name"
          defaultValue=""
        />
      )}

      <ReferenceInput
        source="user_id"
        reference="users"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="first_name" />
      </ReferenceInput>
      <ReferenceInput
        // label="Plant Name"
        source="sap_plant_id"
        reference="sap_plants"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="order_number" defaultValue="" />
      <SelectInput
        style={selectInputStyle}
        source="mode_of_delivery"
        choices={modeOfDeliveryArray}
      />
      <DateTimeInput
        source="order_date_from"
        // label="Order Date From"
        maxDate={new Date()}
      />
      <DateTimeInput
        source="order_date_to"
        // label="Order Date To"
        maxDate={new Date()}
      />
      {getDigitalOrderStatusChoices().length > 0 && (
        <SelectInput
          source="customer_order_status"
          // label="Order Status"
          choices={getDigitalOrderStatusChoices()}
        />
      )}
      {permissions === "isSap" &&
        props.resource !== "sap_digital_app_orders" &&
        getLocalStorageKey("show_all_orders") && (
          <SelectInput
            source="is_app_order"
            // label="Is App Order"
            choices={[
              { id: "Yes", name: "Yes" },
              { id: "No", name: "No" },
            ]}
          />
        )}
      {permissions === "isSap" &&
        props.resource === "sap_digital_app_orders" && (
          <SelectInput
            source="on_hold"
            // label="On Hold"
            choices={[
              { id: "true", name: "Yes" },
              { id: "false", name: "No" },
            ]}
          />
        )}
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TextInput source="shipment_number" defaultValue="" />
        )}
      {/* {sdoFieldSettings &&
        sdoFieldSettings.load_number &&
        sdoFieldSettings.load_number.enabled && (
          <TextInput source="load_number" defaultValue="" />
        )} */}
      <TextInput source="product" defaultValue="" />
      <TextInput source="ordered_quantity" defaultValue="" />
      {/* <SelectInput
        source="received"
        choices={[
          { id: "true", name: "Yes" },
          { id: "false", name: "No" },
        ]}
      /> */}
      {/* <SelectInput
        source="is_app_order"
        label="Show App Orders"
        choices={[
          { id: "true", name: "Yes" },
          { id: "false", name: "No" },
        ]}
      /> */}

      {localStorageLocale == "en-GB" ? (
        <SelectArrayInput
          source="area"
          label="Area"
          choices={[
            { id: "109", name: "109 - Witherley" },
            { id: "110", name: "110 - London Aggregates" },
            { id: "201", name: "201 - South West Aggregates" },
            { id: "203", name: "203 - Specialist Sands" },
            { id: "208", name: "208 - Mendip Aggregates" },
            { id: "211", name: "211 - Wales" },
            { id: "410", name: "410 - North England" },
            { id: "420", name: "420 - Midlands" },
            { id: "425", name: "425 - Lincolnshire" },
            { id: "AGK", name: "AGK - Kendall Aggregates" },
            { id: "GLS", name: "GLS - Glensanda" },
            { id: "SCA", name: "SCA - Scotland Aggregates" },
            { id: "ANE", name: "ANE - Aggregates North East" },
            { id: "ANW", name: "ANW - Aggregates North West" },
          ]}
        />
      ) : null}

      {localStorageLocale == "fr-FR" ? (
        <SelectArrayInput
          source="area"
          label={translate("resources.sap_digital_app_orders.fields.area")}
          choices={[
            { id: "Sud Est", name: "Sud Est" },
            { id: "Ouest", name: "Ouest" },
            { id: "Nord", name: "Nord" },
            { id: "Famy", name: "Famy" },
          ]}
        />
      ) : null}

      {localStorageLocale == "en-GB" ? (
        <SelectInput
          source="contract_type"
          label="Order Type"
          choices={[
            { id: "C1", name: "C1" },
            { id: "C6", name: "C6" },
          ]}
        />
      ) : null}

      <SelectInput
        source="product_type"
        label="Product Type"
        choices={[
          { id: "cement", name: "Cement" },
          // { id: "asphalt", name: "Asphalt" },
          { id: "aggregate", name: "Aggregate" },
          { id: "asphalt", name: "Asphalt" },
          { id: "express_asphalt", name: "Express Asphalt" },
        ]}
      />
    </Filter>
  );
};

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const ListActions = ({
//     displayedFilters,
//     filters,
//     filterValues,
//     resource,
//     showFilter,
//     total,
//     currentSort,
//     exporter
// }) => (
//         <TopToolbar>
//             {filters && React.cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <ExportButton
//                 disabled={total === 0}
//                 resource={resource + '_csv'}
//                 sort={currentSort}
//                 filter={filterValues}
//                 exporter={exporter}
//             />
//             <RefreshButton />
//         </TopToolbar>
//     )

// const ListActions = (props) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalMsg, setModalMsg] = React.useState('')
//     const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//     const csvResource = resource + '_csv'
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;

//     const callExport = (e) => {
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//       options.method = 'GET';
//       fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//         .then(res => {
//             return res.json();
//         }).then(jsonD => {
//           console.log('jsonD VVVVVVx===>', jsonD.data);
//           const msg = jsonD.data? jsonD.data[0].message : '';
//           setModalShow(true);
//           setModalMsg(msg);
//         });
//     }
//     const exporterModal = () => {
//       return ''
//     }

//     const onClose = () => {
//       setModalShow(false)
//     }
//     return (
//       <>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           onClick={(e) => callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporterModal}
//           maxResults={maxResults}
//           />
//       </TopToolbar>
//       {
//             modalShow &&
//             <Modal open={modalShow} onClose={onClose} center>
//               <h3>{modalMsg}</h3>
//             </Modal>
//       }
//       </>
//     )
//   }

const ListActions = (props) => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     modalShow: false,
  //     modalMsg: "",
  //     customFilterUrl:
  //       'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
  //   };
  // }
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(location.search);

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    // console.log('callExport...e', e);
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data[0].result);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          const res = jsonD.data[0].result;
          const f_date = moment(jsonD.data[0].f_date).format("MM/DD/YYYY");
          const t_date = moment(jsonD.data[0].t_date).format("MM/DD/YYYY");
          // console.log('f_date= inside callback', moment(f_date).format('MM/DD/YYYY'));
          Swal.fire({
            html:
              res && msg
                ? msg + "&nbsp" + f_date + "&nbspto&nbsp" + t_date
                : msg,
            icon: res ? "success" : "info",
            width: 640,
          });
          // this.setState({ modalShow: true });
          // this.setState({ modalMsg: msg });
        });
    } else {
      setCustomFilterUrl(location.search);
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          const res = jsonD.data[0].result;
          const f_date = moment(jsonD.data[0].f_date).format("MM/DD/YYYY");
          const t_date = moment(jsonD.data[0].t_date).format("MM/DD/YYYY");
          Swal.fire({
            html:
              res && msg
                ? msg + "&nbsp" + f_date + "&nbspto&nbsp" + t_date
                : msg,
            icon: res ? "success" : "info",
            width: 640,
          });
          // this.setState({ modalShow: true });
          // this.setState({ modalMsg: msg });
        });
    }
  };
  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
                        onClick={(e) => this.callExport(e)}
                        disabled={total === 0}
                        resource={csvResource}
                        sort={currentSort}
                        filter={{ ...filterValues, ...permanentFilter }}
                        exporter={this.exporterModal}
                        maxResults={maxResults}
                    /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </>
  );
};

// const digitalOrdersExporter = (digitalOrders, fetchRelatedRecords, permissions) => {
//     fetchRelatedRecords(digitalOrders, 'business_id', 'businesses').then(businesses => {
//         const ordersForExport = digitalOrders.map(order => ({
//             ...order,
//             sold_to_name: businesses[order.business_id].name,
//             expected_date: `${moment(order.delivery_date_from).format('MM/DD/YYYY')} - ${moment(order.delivery_date_from).add(2, 'days').format('MM/DD/YYYY')}`,
//             order_date: moment(order.creation_date).format('MM/DD/YYYY, H:mm:ss a'),
//             order_status: order.customer_order_status_desc,
//             ship_to_name: order.business_site,
//             local_po_note: order.customer_ref_number,
//             first_seen_in_lr: moment(order.created_at).format('MM/DD/YYYY, H:mm:ss a'),
//         }));
//         const fieldsArr = ['order_date', 'sold_to_name', 'order_number', 'mode_of_delivery', 'products', 'shipment_nos', 'load_nos', 'received', 'order_status', 'ship_to_name', 'expected_date', 'local_po_note', 'on_hold'] // select and order fields in the export
//         if (permissions === 'isSap') {
//             fieldsArr.push('first_seen_in_lr')
//         }
//         const csv = convertToCSV({
//             data: ordersForExport,
//             fields: fieldsArr
//         });
//         const BOM = '\uFEFF'
//         downloadCSV(`${BOM} ${csv}`, 'digitalOrders')
//         // downloadCSV(csv, 'digitalOrders'); // download as 'digitalOrders.csv` file
//     });
// }

const DigitalOrdersPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);

const FormattedOrderNumber = ({ source }) => {
  const record = useRecordContext();
  return (
    <span
      className={record.sap_order_failed_message ? "e1-error" : ""}
      style={{
        fontSize: "0.875rem",
        fontFamily: "NeueEinstellung,Arial,sans-serif",
        fontWeight: "400",
        lineHeight: "1.43",
      }}
    >
      {record.order_number}
    </span>
  );
};

const CustomBulkActionButton = ({ selectedIds, resource }) => {
  const dataProvider = useDataProvider();
  const [selectedRecords, setSelectedRecords] = useState([]);
  const notify = useNotify();
  const unselectAll = useUnselectAll(resource);

  useEffect(() => {
    if (selectedIds.length > 0) {
      dataProvider
        .getMany(resource, { ids: selectedIds })
        .then(({ data }) => setSelectedRecords(data))
        .catch((error) => {
          notify("Error fetching records", { type: "warning" });
        });
    }
  }, [selectedIds, dataProvider, resource, notify]);

  const postE1Api = () => {
    const orderNumberArray = selectedRecords.map(
      (record) => record.order_number
    );

    let dataToSend = {
      order_number: orderNumberArray,
    };

    console.log("duppppppppppppppppppp", dataToSend);

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";
    options.body = JSON.stringify(dataToSend);
    fetch(`${apiUrl}/sap_digital_orders/create_order`, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json) {
          console.log("json reply", json);
          // setTimeout(()=>{
          if (json.status) {
            Swal.fire({
              html: `${json.data}`,
              icon: "success",
            }).then((result) => {
              unselectAll(resource); // Optionally unselect all records after action
              // navigate(`/discount_schemes/${json.id}/show`)
            });
          } else {
            Swal.fire({
              icon: "error",
              title: `${json.data}`,
              text: "",
            }).then((result) => {
              unselectAll(resource); // Optionally unselect all records after action
              // navigate(`/discount_schemes/${json.id}/show`)
            });
          }
        }
      });
  };

  const SendToE1Button = () => {
    Swal.fire({
      text: "Are you sure you want to send this order with the following details to E1?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        postE1Api();
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <Button onClick={SendToE1Button} disabled={selectedIds.length <= 0}>
      Send to E1 ({selectedIds.length})
    </Button>
  );
};

const DigitalOrdersList = (props) => {
  // state = {
  //     moodalShow: false,
  // }
  // exporter = (data) => {
  //     const msg = data[0].message;
  //     this.setState({
  //         moodalShow: true,
  //         modalMsg: msg,
  //     })
  // }

  // onClose = () => {
  //     this.setState({
  //         moodalShow: false,
  //     })
  // }

  // const { state, props, permissions } = this;
  console.log("props for digital orders==>", props);
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const location = useLocation();

  // console.log('country code', localStorageLocale);

  const PostPanel = (props) => {
    const lineItems = props?.record?.digital_order_line_items;
    console.log("post panel", props, lineItems);
    const capitalString = (str) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    return (
      <div className="soldToDetails">
        <table>
          <tr></tr>
          <div>
            <tr>
              <th>Mode</th>
              <th>Start time</th>
              <th>End time</th>
              <th>Comment</th>
              <th>Duration</th>
              <th>Truck type</th>
              <th>Quantity</th>
              <th>Material name</th>
              <th>Material no</th>
              <th>Plant name</th>
              <th>Plant code</th>
            </tr>
            {lineItems.map((lineItem) => {
              return (
                <tr>
                  <td>{capitalString(lineItem?.truck_or_trips)}</td>
                  <td>{lineItem?.start_time}</td>
                  <td>{lineItem?.end_time}</td>
                  <td>{lineItem?.comment || "-"}</td>
                  <td>{lineItem?.duration}</td>
                  <td>{lineItem?.truck_type}</td>
                  <td>
                    {lineItem?.truck_or_trips == "tonnage"
                      ? lineItem?.quantity
                      : "-"}
                  </td>
                  <td>{lineItem?.product_master?.name}</td>
                  <td>{lineItem?.material_no}</td>
                  <td>{lineItem?.plant_name}</td>
                  <td>{lineItem?.plant_code}</td>
                </tr>
              );
            })}
          </div>
        </table>
      </div>
    );
  };

  return (
    <>
      <Scrollbars className="scroll-container">
        <List
          title={translate(
            "resources.sap_digital_app_orders.fields.digital_order"
          )}
          pagination={<DigitalOrdersPagination />}
          sort={{ field: "creation_date", order: "DESC" }}
          actions={<ListActions />}
          // exporter={exporter}
          {...props}
          filters={
            <DigitalOrdersFilter permissions={props} location={location} />
          }
          // bulkActionButtons={false}
        >
          <Datagrid
            rowClick="show"
            expand={countryCode == "FR" ? <PostPanel /> : null}
            bulkActionButtons={
              countryCode == "GB" ? <CustomBulkActionButton /> : false
            }
            className="order-list-white-space"
          >
            <FormattedOrderNumber source="order_number" />
            <DateField source="creation_date" showTime />
            {/* <TextField
              // label="Order Status"
              sx={{ backgroundColor: 'red',borderRadius: 2.5,color:'white',padding:0.4  }}
              source="customer_order_status_desc"
            /> */}

            <OrderStatus
              // label="Expected Date"
              label="Order Status"
              source="customer_order_status_desc"
              order_status="customer_order_status"
            />
            <DateField
              source="delivery_date_from"
              label={translate(
                "resources.sap_digital_app_orders.fields.delivery_date"
              )}
            />

            {localStorageLocale == "en-GB" ? (
              <TextField source="area" label="Area/RCC" />
            ) : null}

            <ReferenceField
              source="business_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>

            {localStorageLocale == "en-GB" && (
              <TextField label="Sent to E1 by" source="admin_user_name" />
            )}

            <TextField source="business_site" />

            <ReferenceField
              source="user_id"
              reference="users"
              link="show"
              allowEmpty
            >
              <TextField source="first_name" />
            </ReferenceField>

            {/* <TextField
                source="sap_plant"
                label="Plant Name"
                sortable={false}
              /> */}
            {localStorageLocale == "en-GB" && (
              <CamelCaseField source="mode_of_delivery" />
            )}
            {/* <TextField source="is_app_order" sortable={false} /> */}

            {/* <TextField
              source="sap_plant"
              // label="Plant Name"
              sortable={false}
            /> */}

            {localStorageLocale == "en-GB" ? (
              <TextField source="contract_type" label="Order Type (C1,C6)" />
            ) : null}

            <TextField
              // source={`${
              //   permissions === "isManual" ? "products_manual" : "products"
              // }`}
              // label={`${
              //   permissions === "isManual"
              //     ? "(Ordered Qty/Dispatched Qty) Products"
              //     : "(Ordered Qty) Products"
              // }`}
              source="products"
              sortable={false}
            />
            {/* {sdoFieldSettings &&
              sdoFieldSettings.shipment_number &&
              sdoFieldSettings.shipment_number.enabled && (
                <TextField source="shipment_nos" />
              )}
            {sdoFieldSettings &&
              sdoFieldSettings.load_number &&
              sdoFieldSettings.load_number.enabled && (
                <TextField source="load_nos" />
              )}
            <TextField source="received" sortable={false} /> */}
            {/* <TextField
                label="Order Status"
                source="customer_order_status_desc"
              /> */}
            {/* <TextField label="Ship To Name" source="business_site" /> */}

            {/* <ReferenceField
                label="Ship To Name"
                source="sap_business_site_id"
                reference="sap_business_sites"
                link="show"
                allowEmpty
              >
                <TextField source="name" />
              </ReferenceField> */}
            {/* <ExpectedDateField
              // label="Expected Date"
              source="delivery_date_from"
            /> */}
            {/* <TextField
              // label="Local PO Note"
              source="customer_ref_number"
            /> */}
            {/* <TextField source="payment_method" />
                            <PaymentAmountField source="payment_amount" />
                            <TextField source="payment_status" />
                            {
                                permissions === 'isSap' &&
                                <DateField label="Date 1st seen in LR" source="created_at" />
                            }
                            {
                                permissions === 'isSap' && props.resource !== "sap_digital_app_orders" && showAllOrders &&
                                <TextField label="Is App Order" source="is_app_order" />
                            }
                            {
                                permissions === 'isSap' && props.resource === "sap_digital_app_orders" &&
                                <BooleanField label="On Hold" source="on_hold" />
                            } */}
            {/* {
                        permissions === 'isManual' &&
                        <EditButton />
                    } */}
            <ShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </>
  );
};

export default DigitalOrdersList;
